module.exports = __webpack_public_path__ + "img/25_photo.e117a43c.png";